import ObjectsGroupDetails from './component'

export default ObjectsGroupDetails